<div class="card panel-monsido-card max-height most-frequent-summary d-flex flex-column">
    <div class="card-header">
        <h2 class="font-weight-300" translate>Most Frequent</h2>
    </div>
    <div class="card-body pb-1 row flex-grow-1 d-flex align-items-stretch">
        <div class="col-48">
            <mon-spinner [loading]="loading">
                <h3 class="font-weight-300 text-grey text-center my-8"
                    *ngIf="allEmpty"
                    [attr.aria-label]="'No content was found' | translate"
                    translate>
                    No content was found
                </h3>
                <div class="row d-flex flex-wrap align-items-stretch" *ngIf="!allEmpty">
                    <ng-container *ngFor="let type of types;">
                        @let data = mostFrequent[type];
                        <div class="col-16 text-center pb-3 d-flex flex-column"
                             *ngIf="data && data.title"
                             [attr.aria-label]="data.label">
                            <span class="text-grey fa-4x mb-1" [ngClass]="mostFrequentClass(data)"></span>
                            <span class="text-capitalize mt-auto">{{data.title}}</span>
                            <span class="most-frequent-label font-weight-500">{{data.label}}</span>
                            <span>{{data.value / data.total | monNumber:'0.[00]%'}}</span>
                            <div class="progress-xxs progress-square mt-2">
                                <ngb-progressbar class="mr-2" [value]="(data.value * 100 / data.total) || 0"></ngb-progressbar>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mon-spinner>
        </div>
    </div>
    <div class="card-footer bg-white text-right">
        <a data-test="summary-link-most-frequent" uiSref="base.customer.domain.statistics.visitors.summary" class="text-uppercase" [attr.aria-label]="'Go to most visits pages' | translate">
            <span translate>Visitor Overview</span>
            <span class="fas fa-angle-right ml-1" aria-hidden="true"></span>
        </a>
    </div>
</div>
